import * as Swiper from 'swiper/dist/js/swiper.js';
import '../../interfaces/slider.interface';
import './slider.component.scss';
var Slider = /** @class */ (function () {
    function Slider() {
    }
    Slider.init = function (container, config) {
        // tslint:disable-next-line:no-unused-expression
        new Swiper(container, config);
    };
    return Slider;
}());
export default Slider;



//////////////////
// WEBPACK FOOTER
// ./components/slider/slider.component.ts
// module id = 6
// module chunks = 0